import trackEvent from "@analytics/utils/trackEvent";

const CampaignAnalyticsService = {
  addConnectedEmailAccount: (id: string) => trackEvent("Connected Email Account Added", { id }),
  addEmailTag: (name: string) => trackEvent("Campaign Email Tag Added", { name }),
  applyNewTemplate: (id: string) => trackEvent("Campaign New Template Applied", { id }),
  applySavedTemplate: (id: string) => trackEvent("Campaign Saved Template Applied", { id }),
  applyStandardTemplate: (id: string) => trackEvent("Campaign Standard Template Applied", { id }),
  createCampaign: (id: string, numberOfContacts: number) =>
    trackEvent("Campaign Created", { id, number_of_contacts: numberOfContacts }),
  deleteAttachment: (id: string) => trackEvent("Campaign Attachment Deleted", { id }),
  deleteCampaign: (id: string) => trackEvent("Campaign Deleted", { id }),
  generateEmails: (id: string) => trackEvent("Campaign Emails Generated", { id }),
  leadAdded: () => trackEvent("Lead Added"),
  leadRemoved: () => trackEvent("Lead Removed"),
  outcomeUpdated: (value: string, emailId: number) =>
    trackEvent("Campaign Outcome Updated", { email_id: emailId, value }),
  saveAttachment: (id: string) => trackEvent("Campaign Attachment Saved", { id }),
  sendCampaign: (id: string, numberOfContacts: number) =>
    trackEvent("Campaign Sent", { id, number_of_contacts: numberOfContacts }),
  sendTestEmail: () => trackEvent("Campaign Test Email Sent"),
} as const;

export default CampaignAnalyticsService;
